const prefix = "/authentication";
export const authAPI = {
  login: prefix + "/login",
  validateOtpGetToken: prefix + "/validate-otp-get-token",
  logout: prefix + "/logout",
};
